import { PayloadAction } from '../../../store.model';
import { ActionType } from '../focus-selector.action';
import { FocusSelectorState } from '../focus-selector.state';
import {
    createSelectedGoals,
    findGoal,
    makeRows,
    selectGoals,
    updateGoalsCollection,
} from '../load-goals/load-goals.function';
import { LoadGoalsGrid } from '../model/focus-selector-load-goals.grid.model';
import { ProjectionEvaluationRangeId } from '../model/focus-selector-projection-evaluation-range.enum';

import { FocusSelectorSelectGoalRow } from './load-goals-select.action';

export function focusSelectorSelectGoalRowReducer(
    state: FocusSelectorState,
    action: PayloadAction<ActionType, FocusSelectorSelectGoalRow>,
): FocusSelectorState {
    const { rowAndMetricId, projectionEvaluationColumn } = action.payload;
    const loadGoalsSelection: LoadGoalsGrid['selection'] = {
        ...state.loadGoalsGrid?.selection,
    };
    const { goals: gridSelectedGoals, projectionEvalCol } = loadGoalsSelection;
    const currSelectedGoal = findGoal(rowAndMetricId, gridSelectedGoals);

    if (projectionEvaluationColumn != null) {
        projectionEvalCol.metricId = rowAndMetricId;
        projectionEvalCol.range = projectionEvaluationColumn;

        if (currSelectedGoal == null) {
            const goalToSelect = findGoal(rowAndMetricId, state.goals);
            loadGoalsSelection.goals.push(goalToSelect);
        }
    } else {
        if (currSelectedGoal != null) {
            loadGoalsSelection.goals = gridSelectedGoals.filter(
                (selectedGoal) => selectedGoal.metricId !== rowAndMetricId,
            );

            if (projectionEvalCol.metricId === rowAndMetricId) {
                projectionEvalCol.metricId =
                    loadGoalsSelection.goals.length > 0
                        ? loadGoalsSelection.goals[0].metricId
                        : null;
                projectionEvalCol.range = ProjectionEvaluationRangeId.DAY_30;
            }
        } else {
            const goalToSelect = findGoal(rowAndMetricId, state.goals);
            loadGoalsSelection.goals.push(goalToSelect);

            projectionEvalCol.metricId = rowAndMetricId;
            projectionEvalCol.range = ProjectionEvaluationRangeId.DAY_30;
        }
    }

    const selectedMetricIds = loadGoalsSelection.goals.map(
        (goal) => goal.metricId,
    );

    const updatedGoalList = selectGoals(state.goals, selectedMetricIds);
    const updatedGoalRows = makeRows(updatedGoalList);
    const selectedGoalsData = createSelectedGoals(
        selectedMetricIds,
        updatedGoalList,
        state.goalsCollection,
        projectionEvalCol.range,
        null,
        true,
    );
    const selectedGoals = { ...state.selectedGoals };
    if (projectionEvaluationColumn != null) {
        selectedGoals[rowAndMetricId] = selectedGoalsData[rowAndMetricId];
    }

    const updatedGoalsCollection = updateGoalsCollection(
        selectedGoals,
        state.goalsCollection,
        updatedGoalList,
        state.coachableMetrics,
    );

    return {
        ...state,
        selectedGoals,
        goalsCollection: updatedGoalsCollection,

        loadGoalsGrid: {
            ...state.loadGoalsGrid,
            rows: updatedGoalRows,
            sortDefs: [...state.loadGoalsGrid.sortDefs],
            selection: loadGoalsSelection,
        },
    };
}
